module.exports = __webpack_public_path__ + "img/import_export.9155496e.svg";